import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-h-screen overflow-hidden flex flex-col h-screen" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { convertDictionaryToObject } from 'smile_ui_alegra/dictionary'
import { onMounted, ref, computed, watch } from 'vue'
import { store } from '@/vue/store'
import { useRoute, useRouter } from 'vue-router'
import propsTopbar from '@/config/Topbar'

// import NotificationBox from '@/vue/components/NotificationBox.vue'
// import * as SScreenSkeleton from '@/vue/components/SScreenSkeleton/index'
import SScreenSkeleton from 'smile_ui_alegra/SScreenSkeleton'
import NotificationBoxTop from '@/vue/components/NotificationBoxTop.vue'
import GlobalWebComponents from '@/vue/components/GlobalWebComponents.vue'
import SLayout from 'smile_ui_alegra/sLayout'
import sTopbar from 'smile_ui_alegra/sTopbar'
import sSidebar from 'smile_ui_alegra/sSidebarAC'
import useMicrofront from '@/vue/composables/useMicrofront'
// import sidebarLinks from '@/config/Menu'

interface IRouteChangeEvent {
  to: {
    fullPath: string
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRoute()
const sRouter = useRouter()
const { loadUserInfo, loading, sentryInit, getHasOnlyInvoiceCustomUi } = useMicrofront()

/**
 * Initializes Sentry for error tracking and monitoring.
 * This function should be called at the start of the application to ensure
 * that any errors or performance issues are captured and reported to Sentry.
 */
sentryInit()

const loadingMicro = computed(() => store.LOADING)
const key = computed((): string => {
  const domain = router.path.split('/')[1]
  const routerKey = router.name
    ? `${router.name.toString().split('-')[0]}-${router.name.toString().split('-')[1]}-${domain}`
    : ''

  return routerKey
})
const moduleClass = ref(key.value)
// const baseMenu = ref(sidebarLinks)// Se comenta porque el menu carga de smile-ui-alegra
const hasOnlyInvoiceCustomUi = ref(false)

window.addEventListener('microfrontend-route-change', (event: Event) => {
  const customEvent = event as CustomEvent<IRouteChangeEvent>
  const { to } = customEvent.detail
  sRouter.push(to.fullPath)
})

onMounted(async () => {
  await reloadUserInfo()
  hasOnlyInvoiceCustomUi.value = await getHasOnlyInvoiceCustomUi()
  localStorage.setItem('hasOnlyInvoiceCustomUi', hasOnlyInvoiceCustomUi.value.toString())
})

const reloadUserInfo = async () => await loadUserInfo(convertDictionaryToObject())

watch(
  key,
  value => {
    if (value) moduleClass.value = value?.split('-')[0]
    store.LOADING = false
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NotificationBoxTop),
    _createVNode(GlobalWebComponents),
    _createVNode(_unref(SLayout), { onReloadUserInfo: reloadUserInfo }, {
      "s-sidebar": _withCtx(() => [
        _createVNode(_unref(sSidebar), {
          loading: _unref(loading),
          "active-single-spa": true,
          "has-only-invoice-custom-ui": hasOnlyInvoiceCustomUi.value
        }, null, 8, ["loading", "has-only-invoice-custom-ui"])
      ]),
      "s-topbar": _withCtx(() => [
        _createVNode(_unref(sTopbar), _normalizeProps(_guardReactiveProps(_unref(propsTopbar))), null, 16)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(moduleClass.value)
        }, [
          (loadingMicro.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(SScreenSkeleton), {
                  component: _unref(store).TYPE_LOADING
                }, null, 8, ["component"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(), _createBlock(_component_router_view, { key: key.value }))
              ]))
        ], 2)
      ]),
      _: 1
    })
  ]))
}
}

})